import { adminRequest } from './adminApi'

export interface StorageBucketsResponse {
  image: string
  audio: string
  video: string
  text: string
}

export interface StorageLocalRootsResponse {
  image_root: string
  audio_root: string
  video_root: string
  text_root: string
}

export interface StorageConfigResponse {
  backend: string
  s3_endpoint: string
  s3_region: string
  presign_ttl_sec: number
  buckets: StorageBucketsResponse
  local_roots: StorageLocalRootsResponse
  s3_credentials_configured: boolean
  asset_signing_key_configured: boolean
}

export interface StorageConfigPayload {
  backend: 'local' | 's3'
  s3_endpoint: string
  s3_region: string
  presign_ttl_sec: number
  buckets: StorageBucketsResponse
  local: StorageLocalRootsResponse
  s3_access_key?: string
  s3_secret_key?: string
}

export interface TestStorageResponse {
  ok: boolean
  backend: string
  bucket: string
  error?: string
}

export function getStorageConfig(): Promise<StorageConfigResponse> {
  return adminRequest<StorageConfigResponse>('/v1/admin/storage/config')
}

export function putStorageConfig(
  payload: StorageConfigPayload,
): Promise<{ saved: boolean; restart_required: boolean }> {
  return adminRequest<{ saved: boolean; restart_required: boolean }>('/v1/admin/storage/config', {
    method: 'PUT',
    body: payload,
  })
}

export function deleteStorageConfig(): Promise<{ reset: boolean; restart_required: boolean }> {
  return adminRequest<{ reset: boolean; restart_required: boolean }>('/v1/admin/storage/config', {
    method: 'DELETE',
  })
}

export function testStorage(payload?: StorageConfigPayload): Promise<TestStorageResponse> {
  return adminRequest<TestStorageResponse>('/v1/admin/storage/test', {
    method: 'POST',
    body: payload,
  })
}
